import { getAIReferrerSource } from '~/utils/analytics'

/**
 * 分析工具配置插件
 * 配置 Google Analytics 和 Clarity 的 cookie 域，确保跨子域名用户识别
 */
export default defineNuxtPlugin(() => {
  // 仅在生产环境执行
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  // 配置 Google Analytics cookie 域
  // 使用 'auto' 自动检测根域名，避免 www.musicmint.ai 和 musicmint.ai 被识别为不同用户
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-VP6MS1BENZ', {
      cookie_domain: 'auto',
      cookie_flags: 'SameSite=None;Secure'
    })
  }

  // 配置 Microsoft Clarity cookie 域
  // Clarity 默认行为较好，但显式设置域名确保一致性
  if (typeof window !== 'undefined' && window.clarity) {
    // Clarity 会自动处理 cookie 域，无需额外配置
    // 如果有问题，可以在 Clarity 控制台中设置域名
  }

  const aiReferrer = getAIReferrerSource(document.referrer)
  if (aiReferrer) {
    const setGeoTags = () => {
      window.clarity?.('set', 'traffic_source_type', 'geo')
      window.clarity?.('set', 'ai_referrer', aiReferrer)
    }
    if (window.clarity) setGeoTags()
    else window.addEventListener('load', setGeoTags, { once: true })
  }
})

// 类型声明
declare global {
  interface Window {
    gtag?: (...args: any[]) => void
    clarity?: (...args: any[]) => void
  }
}
